export default __webpack_public_path__ + "static/media/vaasstarterprata.a1b9693c.svg";